import React from 'react'
import "./home.scss";
import TopDashboard from '../../components/dashboard/TopDashboard';

const Home = () => {
  return (
    <div className="main_wrp">
      <div className="dash_b_wrp">
        <TopDashboard/>
      </div>
    </div>
  );
}

export default Home
